import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import { Switch as SwitchPrimitive } from 'radix-ui'
import * as React from 'react'

const switchVariants = cva(
  'peer inline-flex cursor-pointer shrink-0 items-center rounded-full border border-transparent p-0.5 shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80',
  {
    variants: {
      size: {
        default: 'h-5 w-9',
        sm: 'h-4 w-7',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

const switchThumbVariants = cva(
  'pointer-events-none block rounded-full bg-background ring-0 transition-transform data-[state=unchecked]:translate-x-0 dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground',
  {
    variants: {
      size: {
        default: 'size-4 data-[state=checked]:translate-x-4',
        sm: 'size-3 data-[state=checked]:translate-x-3',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitive.Root>,
  React.ComponentProps<typeof SwitchPrimitive.Root> &
    VariantProps<typeof switchVariants>
>(({ className, size, ...props }, ref) => {
  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      ref={ref}
      className={cn(switchVariants({ size }), className)}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={switchThumbVariants({ size })}
      />
    </SwitchPrimitive.Root>
  )
})
Switch.displayName = 'Switch'

export { Switch }
